import OutlookIntegrationPage, { AddOutlookFormModal } from './pages/Outlook/OutlookIntegrationPage.tsx';

import {
    canManageAccessControl,
    canManageCustomer,
    canManageIntegrations,
    hasWorkistPermissions,
} from '../users/utils';

import {
    CUSTOMER_API_INTEGRATIONS_ADD_PATH,
    CUSTOMER_API_INTEGRATIONS_EDIT_PATH,
    CUSTOMER_API_INTEGRATIONS_PATH,
    CUSTOMER_CUSTOMIZATIONS_PATH,
    CUSTOMER_PLAN_USAGE_PATH,
    CUSTOMER_INTEGRATION_ERP_PATH,
    CUSTOMER_INTEGRATION_BUSINESS_CENTRAL_ADD_PATH,
    CUSTOMER_INTEGRATION_BUSINESS_CENTRAL_EDIT_PATH,
    CUSTOMER_INTEGRATION_BUSINESS_CENTRAL_PATH,
    CUSTOMER_INTEGRATION_BUSINESS_CENTRAL_SETUP_DATA_PATH,
    CUSTOMER_INTEGRATION_NETSUITE_ADD_PATH,
    CUSTOMER_INTEGRATION_NETSUITE_EDIT_PATH,
    CUSTOMER_INTEGRATION_NETSUITE_PATH,
    CUSTOMER_INTEGRATION_OUTLOOK_ADD_PATH,
    CUSTOMER_INTEGRATION_OUTLOOK_EDIT_PATH,
    CUSTOMER_INTEGRATION_OUTLOOK_PATH,
    CUSTOMER_INTEGRATION_QUICKBOOKS_ADD_PATH,
    CUSTOMER_INTEGRATION_QUICKBOOKS_EDIT_PATH,
    CUSTOMER_INTEGRATION_QUICKBOOKS_PATH,
    CUSTOMER_INTEGRATION_MICROTECH_BUERO_PLUS_ADD_PATH,
    CUSTOMER_INTEGRATION_MICROTECH_BUERO_PLUS_EDIT_PATH,
    CUSTOMER_INTEGRATION_MICROTECH_BUERO_PLUS_PATH,
    CUSTOMER_INTEGRATION_SAGE100_ADD_PATH,
    CUSTOMER_INTEGRATION_SAGE100_EDIT_PATH,
    CUSTOMER_INTEGRATION_SAGE100_OAUTH2_CALLBACK_PATH,
    CUSTOMER_INTEGRATION_SAGE100_PATH,
    CUSTOMER_INTEGRATION_DYNAMICS_FINANCE_OPERATIONS_ADD_PATH,
    CUSTOMER_INTEGRATION_DYNAMICS_FINANCE_OPERATIONS_EDIT_PATH,
    CUSTOMER_INTEGRATION_DYNAMICS_FINANCE_OPERATIONS_PATH,
    CUSTOMER_INTEGRATION_ORDERWISE_ADD_PATH,
    CUSTOMER_INTEGRATION_ORDERWISE_EDIT_PATH,
    CUSTOMER_INTEGRATION_ORDERWISE_PATH,
    CUSTOMER_INTEGRATION_ALPHAPLAN_ADD_PATH,
    CUSTOMER_INTEGRATION_ALPHAPLAN_EDIT_PATH,
    CUSTOMER_INTEGRATION_ALPHAPLAN_PATH,
    CUSTOMER_INTEGRATION_ORDAT_ADD_PATH,
    CUSTOMER_INTEGRATION_ORDAT_EDIT_PATH,
    CUSTOMER_INTEGRATION_ORDAT_PATH,
    CUSTOMER_INTEGRATION_SAGE200PROFESSIONAL_ADD_PATH,
    CUSTOMER_INTEGRATION_SAGE200PROFESSIONAL_EDIT_PATH,
    CUSTOMER_INTEGRATION_SAGE200PROFESSIONAL_OAUTH2_CALLBACK_PATH,
    CUSTOMER_INTEGRATION_SAGE200PROFESSIONAL_PATH,
    CUSTOMER_INTEGRATION_SAP_BUSINESS_ONE_ADD_PATH,
    CUSTOMER_INTEGRATION_SAP_BUSINESS_ONE_EDIT_PATH,
    CUSTOMER_INTEGRATION_SAP_BUSINESS_ONE_PATH,
    CUSTOMER_INTEGRATION_CUSTOM_ADD_PATH,
    CUSTOMER_INTEGRATION_CUSTOM_EDIT_PATH,
    CUSTOMER_INTEGRATION_CUSTOM_PATH,
    CUSTOMER_INTEGRATION_SHAREPOINT_PATH,
    CUSTOMER_INTEGRATION_SHAREPOINT_CONNECT_PATH,
    CUSTOMER_INTEGRATION_WEBHOOK_ADD_PATH,
    CUSTOMER_INTEGRATION_WEBHOOK_EDIT_PATH,
    CUSTOMER_INTEGRATION_WEBHOOK_PATH,
    CUSTOMER_INTEGRATION_SFTP_PUBLIC_KEYS_PATH,
    CUSTOMER_INTEGRATION_SMART_INBOX_CONFIG_PATH,
    CUSTOMER_INTEGRATION_SMART_INBOX_PATH,
    CUSTOMER_SMART_INBOX_CATEGORY_EDIT_PATH,
    CUSTOMER_INTEGRATION_WECLAPP_ADD_PATH,
    CUSTOMER_INTEGRATION_WECLAPP_EDIT_PATH,
    CUSTOMER_INTEGRATION_WECLAPP_PATH,
    CUSTOMER_AGENTS_PATH,
    CUSTOMER_DATA_USAGE_PATH,
    CUSTOMER_MFA_PATH,
    CUSTOMER_NOTIFICATIONS_PATH,
    CUSTOMER_PROFILE_PATH,
    CUSTOMER_SAML_PATH,
    CUSTOMER_SSO_PATH,
    CUSTOMER_SSO_ADD_PATH,
    CUSTOMER_SSO_EDIT_PATH,
} from './constants';
import CustomerProfilePage from './pages/CustomerProfilePage.tsx';
import CustomerNotificationsPage from './pages/CustomerNotificationsPage.tsx';
import CustomerAgentsPage from './pages/CustomerAgentsPage.tsx';
import CustomerDataUsagePage from './pages/CustomerDataUsagePage.tsx';
import CustomerSsoPage, { AddSsoConfigFormModal } from './pages/Sso/CustomerSsoPage.tsx';
import CustomerSsoEditPage from './pages/Sso/CustomerSsoEditPage.tsx';
import CustomerSamlPage from './pages/CustomerSamlPage.tsx';
import CustomerCustomizationsPage from './pages/CustomerCustomizationsPage.tsx';
import CustomerPlanUsagePage from './pages/CustomerPlanUsagePage.tsx';
import ApiIntegrationsPage, { AddApiIntegrationFormModal } from './pages/ApiIntegration/ApiIntegrationsPage.tsx';
import ApiIntegrationEditPage from './pages/ApiIntegration/ApiIntegrationEditPage.tsx';
import SftpPublicKeysPage from './pages/SftpPublicKeysPage.tsx';
import MicrotechBueroPlusIntegrationPage, {
    AddMicrotechBueroPlusFormModal,
} from './pages/MicrotechBueroPlus/MicrotechBueroPlusIntegrationPage.tsx';
import MicrotechBueroPlusIntegrationEditPage from './pages/MicrotechBueroPlus/MicrotechBueroPlusIntegrationEditPage.tsx';
import Sage100IntegrationPage, { Sage100OauthCallbackModal } from './pages/Sage100/Sage100IntegrationPage.tsx';
import Sage100IntegrationEditPage from './pages/Sage100/Sage100IntegrationEditPage.tsx';
import Sage100IntegrationAddPage from './pages/Sage100/Sage100IntegrationAddPage.tsx';
import DynamicsFinanceOperationsIntegrationPage from './pages/DynamicsFinanceOperations/DynamicsFinanceOperationsIntegrationPage.tsx';
import { AddDynamicsFinanceOperationsFormModal } from './pages/DynamicsFinanceOperations/DynamicsFinanceOperationsFormModal.tsx';
import DynamicsFinanceOperationsIntegrationEditPage from './pages/DynamicsFinanceOperations/DynamicsFinanceOperationsIntegrationEditPage.tsx';
import Sage200ProfessionalIntegrationPage, {
    AddSage200ProfessionalFormModal,
    Sage200ProfessionalOauthCallbackModal,
} from './pages/Sage200/Sage200IntegrationPage.tsx';
import Sage200IntegrationEditPage from './pages/Sage200/Sage200IntegrationEditPage.tsx';
import WeclappIntegrationPage, { AddWeclappFormModal } from './pages/Weclapp/WeclappIntegrationPage.tsx';
import WeclappIntegrationEditPage from './pages/Weclapp/WeclappIntegrationEditPage.tsx';
import SmartInboxRedirect from './pages/SmartInbox/SmartInboxRedirect.tsx';
import CustomerMfaPage from './pages/CustomerMfaPage.tsx';
import BusinessCentralIntegrationPage, {
    AddBusinessCentralFormModal,
    SetupDataBusinessCentralModal,
} from './pages/BusinessCentralIntegration/BusinessCentralIntegrationPage.tsx';
import BusinessCentralIntegrationEditPage from './pages/BusinessCentralIntegration/BusinessCentralIntegrationEditPage.tsx';
import QuickBooksIntegrationPage, { AddQuickBooksFormModal } from './pages/Quickbooks/QuickBooksIntegrationPage.tsx';
import QuickBooksIntegrationEditPage from './pages/Quickbooks/QuickBooksIntegrationEditPage.tsx';
import NetsuiteIntegrationPage from './pages/NetSuite/NetsuiteIntegrationPage.tsx';
import NetsuiteIntegrationAddPage from './pages/NetSuite/NetsuiteIntegrationAddPage.tsx';
import NetsuiteIntegrationEditPage from './pages/NetSuite/NetsuiteIntegrationEditPage.tsx';
import SapBusinessOneIntegrationPage, {
    AddSapBusinessOneFormModal,
} from './pages/SapBusinessOne/SapBusinessOneIntegrationPage.tsx';
import SapBusinessOneIntegrationEditPage from './pages/SapBusinessOne/SapBusinessOneIntegrationEditPage.tsx';
import CustomIntegrationPage, {
    AddCustomIntegrationFormModal,
} from './pages/CustomIntegration/CustomIntegrationPage.tsx';
import CustomIntegrationEditPage from './pages/CustomIntegration/CustomIntegrationEditPage.tsx';
import ErpIntegrationsPage from './pages/ErpIntegrationsPage.tsx';
import WebhookPage, { AddWebhookFormModal } from './pages/Webhook/WebhookPage.tsx';
import WebhookEditPage from './pages/Webhook/WebhookEditPage.tsx';
import OrderwiseIntegrationPage from './pages/Orderwise/OrderwiseIntegrationPage.tsx';
import OrderwiseIntegrationAddPage from './pages/Orderwise/OrderwiseIntegrationAddPage.tsx';
import OrderwiseIntegrationEditPage from './pages/Orderwise/OrderwiseIntegrationEditPage.tsx';
import OrdatIntegrationPage from './pages/Ordat/OrdatIntegrationPage.tsx';
import OrdatIntegrationAddPage from './pages/Ordat/OrdatIntegrationAddPage.tsx';
import OrdatIntegrationEditPage from './pages/Ordat/OrdatIntegrationEditPage.tsx';
import AlphaplanIntegrationPage from './pages/Alphaplan/AlphaplanIntegrationPage.tsx';
import AlphaplanIntegrationAddPage from './pages/Alphaplan/AlphaplanIntegrationAddPage.tsx';
import AlphaplanIntegrationEditPage from './pages/Alphaplan/AlphaplanIntegrationEditPage.tsx';
import SharePointIntegrationPage, { SharePointConnectModal } from './pages/SharePointIntegrationPage.tsx';
import OutlookIntegrationEditPage from './pages/Outlook/OutlookIntegrationEditPage.tsx';

export default [
    {
        path: CUSTOMER_PROFILE_PATH,
        condition: ({ user }) => canManageCustomer(user),
        component: CustomerProfilePage,
    },
    {
        path: CUSTOMER_NOTIFICATIONS_PATH,
        condition: ({ user }) => canManageCustomer(user),
        component: CustomerNotificationsPage,
    },
    {
        path: CUSTOMER_AGENTS_PATH,
        condition: ({ user }) => canManageCustomer(user),
        component: CustomerAgentsPage,
    },
    {
        path: CUSTOMER_DATA_USAGE_PATH,
        condition: ({ user }) => canManageCustomer(user),
        component: CustomerDataUsagePage,
    },
    {
        path: CUSTOMER_SSO_PATH,
        condition: ({ user }) => canManageAccessControl(user),
        component: CustomerSsoPage,
        children: [
            {
                path: CUSTOMER_SSO_ADD_PATH,
                condition: ({ user }) => canManageAccessControl(user),
                component: AddSsoConfigFormModal,
            },
        ],
    },
    {
        path: CUSTOMER_SSO_EDIT_PATH,
        condition: ({ user }) => canManageAccessControl(user),
        component: CustomerSsoEditPage,
    },
    {
        path: CUSTOMER_SAML_PATH,
        condition: ({ user }) => canManageAccessControl(user),
        component: CustomerSamlPage,
    },
    {
        path: CUSTOMER_MFA_PATH,
        condition: ({ user }) => canManageAccessControl(user),
        component: CustomerMfaPage,
    },
    {
        path: CUSTOMER_CUSTOMIZATIONS_PATH,
        condition: ({ user }) => hasWorkistPermissions(user),
        component: CustomerCustomizationsPage,
    },
    {
        path: CUSTOMER_PLAN_USAGE_PATH,
        condition: ({ user }) => hasWorkistPermissions(user),
        component: CustomerPlanUsagePage,
    },
    {
        path: CUSTOMER_API_INTEGRATIONS_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: ApiIntegrationsPage,
        children: [
            {
                path: CUSTOMER_API_INTEGRATIONS_ADD_PATH,
                condition: ({ user }) => canManageIntegrations(user),
                component: AddApiIntegrationFormModal,
            },
        ],
    },
    {
        path: CUSTOMER_API_INTEGRATIONS_EDIT_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: ApiIntegrationEditPage,
    },
    {
        path: CUSTOMER_INTEGRATION_SFTP_PUBLIC_KEYS_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: SftpPublicKeysPage,
    },
    {
        path: CUSTOMER_INTEGRATION_ERP_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: ErpIntegrationsPage,
    },
    {
        path: CUSTOMER_INTEGRATION_OUTLOOK_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: OutlookIntegrationPage,
        children: [
            {
                path: CUSTOMER_INTEGRATION_OUTLOOK_ADD_PATH,
                condition: ({ user }) => canManageIntegrations(user),
                component: AddOutlookFormModal,
            },
        ],
    },
    {
        path: CUSTOMER_INTEGRATION_OUTLOOK_EDIT_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: OutlookIntegrationEditPage,
    },
    {
        path: CUSTOMER_INTEGRATION_WECLAPP_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: WeclappIntegrationPage,
        children: [
            {
                path: CUSTOMER_INTEGRATION_WECLAPP_ADD_PATH,
                condition: ({ user }) => canManageIntegrations(user),
                component: AddWeclappFormModal,
            },
        ],
    },
    {
        path: CUSTOMER_INTEGRATION_WECLAPP_EDIT_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: WeclappIntegrationEditPage,
    },
    {
        path: CUSTOMER_INTEGRATION_SAGE100_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: Sage100IntegrationPage,
        children: [
            {
                path: CUSTOMER_INTEGRATION_SAGE100_OAUTH2_CALLBACK_PATH,
                condition: ({ user }) => canManageIntegrations(user),
                component: Sage100OauthCallbackModal,
            },
        ],
    },
    {
        path: CUSTOMER_INTEGRATION_SAGE100_ADD_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: Sage100IntegrationAddPage,
    },
    {
        path: CUSTOMER_INTEGRATION_SAGE100_EDIT_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: Sage100IntegrationEditPage,
    },
    {
        path: CUSTOMER_INTEGRATION_MICROTECH_BUERO_PLUS_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: MicrotechBueroPlusIntegrationPage,
        children: [
            {
                path: CUSTOMER_INTEGRATION_MICROTECH_BUERO_PLUS_ADD_PATH,
                condition: ({ user }) => canManageIntegrations(user),
                component: AddMicrotechBueroPlusFormModal,
            },
        ],
    },
    {
        path: CUSTOMER_INTEGRATION_MICROTECH_BUERO_PLUS_EDIT_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: MicrotechBueroPlusIntegrationEditPage,
    },
    {
        path: CUSTOMER_INTEGRATION_DYNAMICS_FINANCE_OPERATIONS_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: DynamicsFinanceOperationsIntegrationPage,
        children: [
            {
                path: CUSTOMER_INTEGRATION_DYNAMICS_FINANCE_OPERATIONS_ADD_PATH,
                condition: ({ user }) => canManageIntegrations(user),
                component: AddDynamicsFinanceOperationsFormModal,
            },
        ],
    },
    {
        path: CUSTOMER_INTEGRATION_DYNAMICS_FINANCE_OPERATIONS_EDIT_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: DynamicsFinanceOperationsIntegrationEditPage,
    },
    {
        path: CUSTOMER_INTEGRATION_SAGE200PROFESSIONAL_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: Sage200ProfessionalIntegrationPage,
        children: [
            {
                path: CUSTOMER_INTEGRATION_SAGE200PROFESSIONAL_ADD_PATH,
                condition: ({ user }) => canManageIntegrations(user),
                component: AddSage200ProfessionalFormModal,
            },
            {
                path: CUSTOMER_INTEGRATION_SAGE200PROFESSIONAL_OAUTH2_CALLBACK_PATH,
                condition: ({ user }) => canManageIntegrations(user),
                component: Sage200ProfessionalOauthCallbackModal,
            },
        ],
    },
    {
        path: CUSTOMER_INTEGRATION_SAGE200PROFESSIONAL_EDIT_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: Sage200IntegrationEditPage,
    },
    {
        path: CUSTOMER_INTEGRATION_BUSINESS_CENTRAL_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: BusinessCentralIntegrationPage,
        children: [
            {
                path: CUSTOMER_INTEGRATION_BUSINESS_CENTRAL_ADD_PATH,
                condition: ({ user }) => canManageIntegrations(user),
                component: AddBusinessCentralFormModal,
            },
            {
                path: CUSTOMER_INTEGRATION_BUSINESS_CENTRAL_SETUP_DATA_PATH,
                condition: ({ user }) => canManageIntegrations(user),
                component: SetupDataBusinessCentralModal,
            },
        ],
    },
    {
        path: CUSTOMER_INTEGRATION_BUSINESS_CENTRAL_EDIT_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: BusinessCentralIntegrationEditPage,
    },
    { path: CUSTOMER_INTEGRATION_SMART_INBOX_PATH, component: SmartInboxRedirect },
    { path: CUSTOMER_INTEGRATION_SMART_INBOX_CONFIG_PATH, component: SmartInboxRedirect },
    { path: CUSTOMER_SMART_INBOX_CATEGORY_EDIT_PATH, component: SmartInboxRedirect },
    {
        path: CUSTOMER_INTEGRATION_NETSUITE_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: NetsuiteIntegrationPage,
    },
    {
        path: CUSTOMER_INTEGRATION_NETSUITE_ADD_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: NetsuiteIntegrationAddPage,
    },
    {
        path: CUSTOMER_INTEGRATION_NETSUITE_EDIT_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: NetsuiteIntegrationEditPage,
    },
    {
        path: CUSTOMER_INTEGRATION_ORDERWISE_ADD_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: OrderwiseIntegrationAddPage,
    },
    {
        path: CUSTOMER_INTEGRATION_ORDERWISE_EDIT_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: OrderwiseIntegrationEditPage,
    },
    {
        path: CUSTOMER_INTEGRATION_ORDERWISE_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: OrderwiseIntegrationPage,
    },
    {
        path: CUSTOMER_INTEGRATION_ORDAT_ADD_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: OrdatIntegrationAddPage,
    },
    {
        path: CUSTOMER_INTEGRATION_ORDAT_EDIT_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: OrdatIntegrationEditPage,
    },
    {
        path: CUSTOMER_INTEGRATION_ORDAT_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: OrdatIntegrationPage,
    },
    {
        path: CUSTOMER_INTEGRATION_ALPHAPLAN_ADD_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: AlphaplanIntegrationAddPage,
    },
    {
        path: CUSTOMER_INTEGRATION_ALPHAPLAN_EDIT_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: AlphaplanIntegrationEditPage,
    },
    {
        path: CUSTOMER_INTEGRATION_ALPHAPLAN_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: AlphaplanIntegrationPage,
    },
    {
        path: CUSTOMER_INTEGRATION_QUICKBOOKS_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: QuickBooksIntegrationPage,
        children: [
            {
                path: CUSTOMER_INTEGRATION_QUICKBOOKS_ADD_PATH,
                condition: ({ user }) => canManageIntegrations(user),
                component: AddQuickBooksFormModal,
            },
        ],
    },
    {
        path: CUSTOMER_INTEGRATION_QUICKBOOKS_EDIT_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: QuickBooksIntegrationEditPage,
    },
    {
        path: CUSTOMER_INTEGRATION_SAP_BUSINESS_ONE_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: SapBusinessOneIntegrationPage,
        children: [
            {
                path: CUSTOMER_INTEGRATION_SAP_BUSINESS_ONE_ADD_PATH,
                condition: ({ user }) => canManageIntegrations(user),
                component: AddSapBusinessOneFormModal,
            },
        ],
    },
    {
        path: CUSTOMER_INTEGRATION_SAP_BUSINESS_ONE_EDIT_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: SapBusinessOneIntegrationEditPage,
    },
    {
        path: CUSTOMER_INTEGRATION_CUSTOM_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: CustomIntegrationPage,
        children: [
            {
                path: CUSTOMER_INTEGRATION_CUSTOM_ADD_PATH,
                condition: ({ user }) => canManageIntegrations(user),
                component: AddCustomIntegrationFormModal,
            },
        ],
    },
    {
        path: CUSTOMER_INTEGRATION_CUSTOM_EDIT_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: CustomIntegrationEditPage,
    },
    {
        path: CUSTOMER_INTEGRATION_SHAREPOINT_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: SharePointIntegrationPage,
        children: [
            {
                path: CUSTOMER_INTEGRATION_SHAREPOINT_CONNECT_PATH,
                condition: ({ user }) => canManageIntegrations(user),
                component: SharePointConnectModal,
            },
        ],
    },
    {
        path: CUSTOMER_INTEGRATION_WEBHOOK_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: WebhookPage,
        children: [
            {
                path: CUSTOMER_INTEGRATION_WEBHOOK_ADD_PATH,
                condition: ({ user }) => canManageIntegrations(user),
                component: AddWebhookFormModal,
            },
        ],
    },
    {
        path: CUSTOMER_INTEGRATION_WEBHOOK_EDIT_PATH,
        condition: ({ user }) => canManageIntegrations(user),
        component: WebhookEditPage,
    },
];
